import { buildSchema } from "@camberi/firecms";

const dailySessionSchema = buildSchema({
    name: "dailySessions",
    properties: {
        date: {
            dataType: "timestamp",
            title: "Date",
            // disabled: true,
            validation: {
                required: true,
            }
        },
        session_id: {
            title: "Session",
            dataType: "reference",
            description: "reference to session",
            collectionPath: "sessions",
            previewProperties: ["title", "time"],
        },
        created_at: {
            dataType: "timestamp",
            title: "Created Date Time",
            disabled: true,
            autoValue: "on_create"
        },
        updated_at: {
            dataType: "timestamp",
            title: "Updated  Date Time",
            disabled: true,
            autoValue: "on_update"
        }
    }
});

dailySessionSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default dailySessionSchema;
